module.exports = __webpack_public_path__ + "static/media/OW.5f6d10d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/OW.svg
// module id = 251
// module chunks = 0